import { useLanguage } from "../LanguageProvider/LanguageProvider";

const PreEstOpService = ({ data }) => {
  const { language } = useLanguage(); // true = Hindi, false = English

  const labels = {
    tableHead: {
      sno: { en: "S.No", hi: "क्रम संख्या" },
      serviceName: { en: "Service Name", hi: "सेवा का नाम" },
      department: { en: "Department", hi: "विभाग" },
      centralState: { en: "Central / State", hi: "केंद्र / राज्य" },
      portal: { en: "Portal", hi: "पोर्टल" },
    },
    footerText: {
      en: `The above information is a guide and indicative in nature. The actual no-objection certificates / approvals and permissions required for a project may vary based on its specific nature, scale, location and other relevant factors. Please obtain detailed information on the policies/guidelines of the concerned department.`,
      hi: `उपरोक्त जानकारी केवल मार्गदर्शक एवं संकेतात्मक है। किसी परियोजना के लिए आवश्यक वास्तविक अनापत्ति प्रमाण पत्र / स्वीकृतियाँ एवं अनुमतियाँ उसकी प्रकृति, आकार, स्थान तथा अन्य संबंधित कारकों के आधार पर भिन्न हो सकती हैं। कृपया संबंधित विभाग की नीतियों/दिशानिर्देशों के अनुसार विस्तृत जानकारी प्राप्त करें।`,
    },
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="overflow-x-auto">
        <table className="min-w-full border border-gray-300">
          <thead className="bg-blue-100 text-left">
            <tr>
              <th className="px-4 py-2 border text-theme-color">
                {language ? labels.tableHead.sno.hi : labels.tableHead.sno.en}
              </th>
              <th className="px-4 py-2 border text-theme-color">
                {language
                  ? labels.tableHead.serviceName.hi
                  : labels.tableHead.serviceName.en}
              </th>
              <th className="px-4 py-2 border text-theme-color">
                {language
                  ? labels.tableHead.department.hi
                  : labels.tableHead.department.en}
              </th>
              <th className="px-4 py-2 border text-theme-color">
                {language
                  ? labels.tableHead.centralState.hi
                  : labels.tableHead.centralState.en}
              </th>
              <th className="px-4 py-2 border text-theme-color">
                {language
                  ? labels.tableHead.portal.hi
                  : labels.tableHead.portal.en}
              </th>
            </tr>
          </thead>

          <tbody>
            {data.map((service, idx) => (
              <tr
                key={service.id}
                className={idx % 2 === 0 ? "bg-white" : "bg-gray-50"}
              >
                <td className="px-4 py-2 border text-theme-color">{service.id}</td>

                {/* Service Name */}
                <td className="px-4 py-2 border text-theme-color">
                  {language && service.serviceName?.hi
                    ? service.serviceName.hi
                    : service.serviceName?.en || service.serviceName}
                </td>

                {/* Department */}
                <td className="px-4 py-2 border text-theme-color">
                  {language && service.department?.hi
                    ? service.department.hi
                    : service.department?.en || service.department}
                </td>

                {/* Central / State */}
                <td className="px-4 py-2 border text-theme-color">
                  {language && service.centralState?.hi
                    ? service.centralState.hi
                    : service.centralState?.en || service.centralState}
                </td>

                {/* Portal */}
                <td className="px-4 py-2 border text-theme-color">
                  <a
                    href={
                      service.portal?.includes("http") ? service.portal : "#"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline"
                  >
                    {service.portal}
                  </a>
                </td>
              </tr>
            ))}

            {/* Footer Disclaimer */}
            <tr className="bg-gray-100">
              <td className="px-4 py-3 border text-sm text-theme-color" colSpan={5}>
                {language ? labels.footerText.hi : labels.footerText.en}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default PreEstOpService;
